export default __webpack_public_path__ + "static/media/Groww.0ca2bb07.png";